var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPedestal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 88C130.746 88 120 98.744 120 112C120 125.254 130.746 136 144 136S168 125.254 168 112C168 98.744 157.254 88 144 88ZM304 88C290.746 88 280 98.744 280 112C280 125.254 290.746 136 304 136S328 125.254 328 112C328 98.744 317.254 88 304 88ZM424 464H416V64C416 28.654 387.346 0 352 0H96C60.654 0 32 28.654 32 64V464H24C10.746 464 0 474.744 0 488C0 501.254 10.746 512 24 512H424C437.254 512 448 501.254 448 488C448 474.744 437.254 464 424 464ZM368 464H80V64C80 55.178 87.178 48 96 48H352C360.822 48 368 55.178 368 64V464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestal);
export default __webpack_public_path__ + "static/media/pedestal.10fb581139d18ae85d3a60b12aedeae9.svg";
export { ForwardRef as ReactComponent };